import React from 'react';
import MUIChip from '@mui/material/Chip';

const Chip = ({ ...properties }) => (<MUIChip {...properties} />);

export default Chip;
